import {
  ClipboardList, Package, GripVertical, Users, X,
  Droplets, SprayCanIcon, Pipette, FileUp, Download, FileText, Briefcase
} from "lucide-react";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { fileUrl } from "../../lib/fileUrl";

const TIPOLOGIE_PRODOTTO = [
  "Detergenti",
  "Disinfettanti e igienizzanti (HACCP)",
  "Sgrassatori",
  "Decalcificanti",
  "Prodotti per lavastoviglie",
  "Accessori per la pulizia",
];

const FREQUENZE = [
  { value: "dopo_uso", label: "Dopo ogni utilizzo" },
  { value: "giornaliero", label: "Giornaliero" },
  { value: "settimanale", label: "Settimanale" },
  { value: "mensile", label: "Mensile" },
];

const GIORNI_SETTIMANA = [
  { value: 0, label: "Lun" },
  { value: 1, label: "Mar" },
  { value: 2, label: "Mer" },
  { value: 3, label: "Gio" },
  { value: 4, label: "Ven" },
  { value: 5, label: "Sab" },
  { value: 6, label: "Dom" },
];

const REPARTI = [
  { value: "tutti", label: "Tutti" },
  { value: "cucina", label: "Cucina" },
  { value: "sala", label: "Sala" },
  { value: "laboratorio", label: "Laboratorio" },
];

export const TaskDialog = ({
  open, onOpenChange, editTask, taskForm, setTaskForm, onSubmit, saving,
  aree, prodotti, operatori,
  toggleGiornoSettimana, toggleProdotto, toggleOperatore
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto rounded-3xl bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground flex items-center gap-2">
          <ClipboardList className="h-5 w-5 text-cyan-500" />
          {editTask ? "Modifica Task" : "Nuovo Task"}
        </DialogTitle>
      </DialogHeader>

      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Area *</Label>
          <Select value={taskForm.area_id} onValueChange={(v) => setTaskForm({ ...taskForm, area_id: v })}>
            <SelectTrigger className="bg-card border-border text-foreground"><SelectValue placeholder="Seleziona area..." /></SelectTrigger>
            <SelectContent className="bg-card border-border">
              {aree.map(a => (
                <SelectItem key={a.id} value={a.id} className="text-foreground">
                  <div className="flex items-center gap-2">
                    <div className="w-3 h-3 rounded-full" style={{ backgroundColor: a.colore }} />
                    {a.nome}
                  </div>
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Nome Task *</Label>
          <Input value={taskForm.nome} onChange={(e) => setTaskForm({ ...taskForm, nome: e.target.value })} placeholder="es. Piano di lavoro inox" className="bg-card border-border text-foreground" />
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Procedura (opzionale)</Label>
          <Textarea value={taskForm.descrizione} onChange={(e) => setTaskForm({ ...taskForm, descrizione: e.target.value })} placeholder="Descrivi la procedura di pulizia..." className="bg-card border-border text-white min-h-[80px]" />
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Frequenza *</Label>
          <Select value={taskForm.frequenza} onValueChange={(v) => setTaskForm({ ...taskForm, frequenza: v })}>
            <SelectTrigger className="bg-card border-border text-foreground"><SelectValue /></SelectTrigger>
            <SelectContent className="bg-card border-border">
              {FREQUENZE.map(f => (<SelectItem key={f.value} value={f.value} className="text-foreground">{f.label}</SelectItem>))}
            </SelectContent>
          </Select>
        </div>

        {taskForm.frequenza === "settimanale" && (
          <div className="space-y-2">
            <Label className="text-foreground/70">Giorni della settimana</Label>
            <div className="flex flex-wrap gap-2">
              {GIORNI_SETTIMANA.map(g => (
                <button key={g.value} type="button" onClick={() => toggleGiornoSettimana(g.value)}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${taskForm.giorni_settimana?.includes(g.value) ? "bg-cyan-500 text-white" : "bg-muted/50 text-foreground hover:bg-muted"}`}>
                  {g.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {taskForm.frequenza === "mensile" && (
          <div className="space-y-2">
            <Label className="text-foreground/70">Giorno del mese</Label>
            <Input type="number" min="1" max="31" value={taskForm.giorno_mese || ""} onChange={(e) => setTaskForm({ ...taskForm, giorno_mese: parseInt(e.target.value) || null })} placeholder="es. 15" className="bg-card border-border text-foreground" />
          </div>
        )}

        {prodotti.length > 0 && (
          <div className="space-y-2">
            <Label className="text-foreground/70">Prodotti da usare</Label>
            <div className="flex flex-wrap gap-2">
              {prodotti.map(p => (
                <button key={p.id} type="button" onClick={() => toggleProdotto(p.id)}
                  className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${taskForm.prodotti_ids?.includes(p.id) ? "bg-emerald-500 text-white" : "bg-muted/50 text-foreground hover:bg-muted"}`}>
                  {p.nome}
                </button>
              ))}
            </div>
          </div>
        )}

        <div className="space-y-3">
          <Label className="text-foreground/70">Assegna a</Label>
          <div className="grid grid-cols-2 gap-2">
            <button type="button" onClick={() => setTaskForm({ ...taskForm, assegnazione_tipo: "operatori", reparto: null })}
              className={`p-3 rounded-xl border text-center transition-all ${taskForm.assegnazione_tipo === "operatori" ? "border-cyan-500 bg-cyan-500/10" : "border-border bg-card hover:bg-muted"}`}>
              <Users className={`h-5 w-5 mx-auto mb-1 ${taskForm.assegnazione_tipo === "operatori" ? "text-cyan-500" : "text-muted-foreground"}`} />
              <span className={`text-sm font-medium ${taskForm.assegnazione_tipo === "operatori" ? "text-foreground" : "text-foreground/60"}`}>Operatori</span>
            </button>
            <button type="button" onClick={() => setTaskForm({ ...taskForm, assegnazione_tipo: "reparto", operatori_ids: [] })}
              className={`p-3 rounded-xl border text-center transition-all ${taskForm.assegnazione_tipo === "reparto" ? "border-cyan-500 bg-cyan-500/10" : "border-border bg-card hover:bg-muted"}`}>
              <Briefcase className={`h-5 w-5 mx-auto mb-1 ${taskForm.assegnazione_tipo === "reparto" ? "text-cyan-500" : "text-muted-foreground"}`} />
              <span className={`text-sm font-medium ${taskForm.assegnazione_tipo === "reparto" ? "text-foreground" : "text-foreground/60"}`}>Reparto</span>
            </button>
          </div>

          {taskForm.assegnazione_tipo === "operatori" && operatori.length > 0 && (
            <div className="p-3 rounded-lg bg-muted/30 border border-border">
              <div className="flex flex-wrap gap-2">
                {operatori.map(o => (
                  <button key={o.id} type="button" onClick={() => toggleOperatore(o.id)}
                    className={`px-3 py-1.5 rounded-lg text-sm font-medium transition-colors ${taskForm.operatori_ids?.includes(o.id) ? "bg-violet-500 text-white" : "bg-muted/50 text-foreground hover:bg-muted"}`}>
                    {o.nome || o.email || o.telefono}
                  </button>
                ))}
              </div>
            </div>
          )}

          {taskForm.assegnazione_tipo === "reparto" && (
            <div className="p-3 rounded-lg bg-muted/30 border border-border">
              <div className="flex flex-wrap gap-2">
                {REPARTI.map(r => (
                  <button key={r.value} type="button" onClick={() => setTaskForm({ ...taskForm, reparto: r.value })}
                    className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${taskForm.reparto === r.value ? "bg-cyan-500 text-white" : "bg-muted/50 text-foreground hover:bg-muted"}`}>
                    {r.label}
                  </button>
                ))}
              </div>
              <p className="text-xs text-muted-foreground mt-2">Tutti gli operatori del reparto vedranno questa task.</p>
            </div>
          )}
        </div>

        <DialogFooter className="gap-2 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1 border-border text-foreground hover:bg-muted">Annulla</Button>
          <Button type="submit" disabled={saving} className="flex-1 bg-cyan-500 hover:bg-cyan-400 text-white font-bold">
            {saving ? "Salvataggio..." : (editTask ? "Salva" : "Crea")}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const AreaDialog = ({
  open, onOpenChange, editArea, areaForm, setAreaForm, onSubmit, saving
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md rounded-3xl bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground flex items-center gap-2">
          <GripVertical className="h-5 w-5 text-cyan-500" />
          {editArea ? "Modifica Area" : "Nuova Area"}
        </DialogTitle>
      </DialogHeader>

      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Nome Area *</Label>
          <Input value={areaForm.nome} onChange={(e) => setAreaForm({ ...areaForm, nome: e.target.value })} placeholder="es. Cucina, Sala, Bagni..." className="bg-card border-border text-foreground" />
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Colore</Label>
          <div className="flex gap-2">
            {["#84cc16", "#3b82f6", "#ef4444", "#a855f7", "#f59e0b", "#06b6d4", "#ec4899"].map(color => (
              <button key={color} type="button" onClick={() => setAreaForm({ ...areaForm, colore: color })}
                className={`w-8 h-8 rounded-full transition-transform ${areaForm.colore === color ? "scale-125 ring-2 ring-white" : ""}`}
                style={{ backgroundColor: color }} />
            ))}
          </div>
        </div>

        <DialogFooter className="gap-2 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1 border-border text-foreground hover:bg-muted">Annulla</Button>
          <Button type="submit" disabled={saving} className="flex-1 bg-cyan-500 hover:bg-cyan-400 text-white font-bold">
            {saving ? "Salvataggio..." : (editArea ? "Salva" : "Crea")}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);

export const ProdottoPuliziaDialog = ({
  open, onOpenChange, editProdotto, prodottoForm, setProdottoForm,
  onSubmit, saving, onSchedaUpload, onDeleteScheda, uploadingScheda, API
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md rounded-3xl bg-card border-border">
      <DialogHeader>
        <DialogTitle className="text-foreground flex items-center gap-2">
          <Package className="h-5 w-5 text-cyan-500" />
          {editProdotto ? "Modifica Prodotto" : "Nuovo Prodotto"}
        </DialogTitle>
      </DialogHeader>

      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Nome Prodotto *</Label>
          <Input value={prodottoForm.nome} onChange={(e) => setProdottoForm({ ...prodottoForm, nome: e.target.value })} placeholder="es. Sgrassatore professionale" className="bg-card border-border text-foreground" />
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Tipologia *</Label>
          <Select
            value={TIPOLOGIE_PRODOTTO.includes(prodottoForm.tipo) ? prodottoForm.tipo : (prodottoForm.tipo ? "__legacy__" : "")}
            onValueChange={(v) => setProdottoForm({ ...prodottoForm, tipo: v === "__legacy__" ? prodottoForm.tipo : v })}
          >
            <SelectTrigger className="bg-card border-border text-foreground">
              <SelectValue placeholder="Seleziona tipologia..." />
            </SelectTrigger>
            <SelectContent className="bg-card border-border">
              {TIPOLOGIE_PRODOTTO.map(t => (
                <SelectItem key={t} value={t} className="text-foreground">{t}</SelectItem>
              ))}
              {/* Compatibilità con valori liberi precedenti */}
              {prodottoForm.tipo && !TIPOLOGIE_PRODOTTO.includes(prodottoForm.tipo) && (
                <SelectItem value="__legacy__" className="text-muted-foreground italic">
                  Precedente: "{prodottoForm.tipo}"
                </SelectItem>
              )}
            </SelectContent>
          </Select>
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70">Note</Label>
          <Textarea value={prodottoForm.note} onChange={(e) => setProdottoForm({ ...prodottoForm, note: e.target.value })} placeholder="Indicazioni sull'uso..." className="bg-card border-border text-white min-h-[60px]" />
        </div>

        <div className="space-y-2">
          <Label className="text-foreground/70 flex items-center gap-2">
            <FileText className="h-4 w-4" />Scheda Tecnica
          </Label>

          {(prodottoForm.scheda_tecnica_url || prodottoForm.scheda_tecnica_nome) ? (
            <div className="flex items-center gap-2 p-3 bg-cyan-500/10 border border-cyan-500/30 rounded-lg">
              <FileText className="h-5 w-5 text-cyan-500" />
              <span className="flex-1 text-sm text-foreground truncate">{prodottoForm.scheda_tecnica_nome}</span>
              {editProdotto?.scheda_tecnica_url && (
                <a href={fileUrl(editProdotto.scheda_tecnica_url)} target="_blank" rel="noopener noreferrer" className="p-1.5 bg-cyan-500 hover:bg-cyan-400 rounded-lg" onClick={(e) => e.stopPropagation()}>
                  <Download className="h-4 w-4 text-white" />
                </a>
              )}
              <button type="button" onClick={onDeleteScheda} className="p-1.5 bg-red-500/20 hover:bg-red-500/40 rounded-lg">
                <X className="h-4 w-4 text-red-500" />
              </button>
            </div>
          ) : (
            <label className="flex items-center justify-center gap-2 p-4 border-2 border-dashed border-border rounded-lg cursor-pointer hover:border-cyan-500/50 hover:bg-cyan-500/5 transition-colors">
              <input type="file" accept=".pdf,image/*" onChange={onSchedaUpload} className="hidden" disabled={uploadingScheda} />
              {uploadingScheda ? (
                <span className="text-sm text-muted-foreground">Caricamento...</span>
              ) : (
                <><FileUp className="h-5 w-5 text-muted-foreground" /><span className="text-sm text-muted-foreground">Carica PDF o immagine</span></>
              )}
            </label>
          )}
        </div>

        <DialogFooter className="gap-2 pt-4">
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="flex-1 border-border text-foreground hover:bg-muted">Annulla</Button>
          <Button type="submit" disabled={saving} className="flex-1 bg-cyan-500 hover:bg-cyan-400 text-white font-bold">
            {saving ? "Salvataggio..." : (editProdotto ? "Salva" : "Crea")}
          </Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
